function normalizeDin(value) {
  const digits = String(value || '').replace(/\D/g, '');
  if (!digits) {
    return '';
  }

  return digits.length <= 8 ? digits.padStart(8, '0') : digits;
}

function normalizeText(value) {
  return String(value || '').trim().toLowerCase();
}

function buildMedicationDrugOption(medication) {
  const din = normalizeDin(medication?.din);
  const productName = String(medication?.productName || medication?.medicationName || '').trim();

  if (!din || !productName) {
    return null;
  }

  return {
    din,
    productName,
    activeIngredientGroupNumber: String(medication?.activeIngredientGroupNumber || '').trim(),
    source: 'medication',
    medicationStatus: medication?.status || 'current',
    dosage: String(medication?.dosage || '').trim(),
    frequency: String(medication?.frequency || '').trim(),
    instructions: String(medication?.instructions || '').trim(),
    createdAt: medication?.createdAt || medication?.startDate || null,
    startDate: medication?.startDate || null,
    endDate: medication?.endDate || null,
  };
}

function compareMedicationPriority(left, right) {
  const leftStatus = left?.status === 'past' ? 1 : 0;
  const rightStatus = right?.status === 'past' ? 1 : 0;
  if (leftStatus !== rightStatus) {
    return leftStatus - rightStatus;
  }

  return new Date(right?.startDate || right?.createdAt || 0) - new Date(left?.startDate || left?.createdAt || 0);
}

export function buildPatientDrugOptions({ medications = [], savedDrugs = [] } = {}) {
  const results = [];
  const seen = new Set();

  const pushUnique = (drug) => {
    const din = normalizeDin(drug?.din);
    const productName = String(drug?.productName || '').trim();

    if (!din || !productName) {
      return;
    }

    const key = `din:${din}`;
    if (seen.has(key)) {
      return;
    }

    seen.add(key);
    results.push({
      ...drug,
      din,
      productName,
    });
  };

  [...(Array.isArray(medications) ? medications : [])]
    .sort(compareMedicationPriority)
    .forEach((medication) => {
      pushUnique(buildMedicationDrugOption(medication));
    });

  (Array.isArray(savedDrugs) ? savedDrugs : []).forEach((drug) => {
    pushUnique({
      din: drug?.din,
      productName: drug?.productName,
      activeIngredientGroupNumber: String(drug?.activeIngredientGroupNumber || '').trim(),
      source: 'saved',
      createdAt: drug?.createdAt || null,
    });
  });

  return results;
}

export function hasMedicationDrugSelection(medication) {
  return Boolean(
    normalizeDin(medication?.din)
    && normalizeText(medication?.productName || medication?.medicationName),
  );
}
